<template>
    <div class="contact-container">
        <div class="intro-section">
            <h2>{{lang.company_intro_title}}</h2>
            <p>{{lang.company_intro_des}}</p>
        </div>
        
        <section class="contact-info-section">
            <div class="section-header">
                <h2>{{ lang.aboutPage }}</h2>
            </div>

            <div class="contact-grid">
                <div class="contact-card">
                    <div class="icon-wrapper">
                        <i class="el-icon-message"></i>
                    </div>
                    <h4>{{ lang.serviceEmail }}</h4>
                    <p>service@bravestarcv.com</p>
                </div>
                
                <div class="contact-card">
                    <div class="icon-wrapper">
                        <i class="el-icon-service"></i>
                    </div>
                    <h4>{{ lang.technicalContacts }}</h4>
                    <p>tech@bravestarcv.com</p>
                </div>

                <div class="contact-card">
                    <div class="icon-wrapper">
                        <i class="el-icon-suitcase"></i>
                    </div>
                    <h4>{{ lang.businessContacts }}</h4>
                    <p>dng@bravestarcv.com</p>
                </div>
                
                <div class="contact-card">
                    <div class="icon-wrapper">
                        <i class="el-icon-location"></i>
                    </div>
                    <h4>{{ lang.companyAddress }}</h4>
                    <p>{{ address }}</p>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    mixins: [],
    name: "aboutPage",
    components: {},
    computed: {
        lang() {
            return this.$store.state.language;
        },
    },
    data() {
        return {
            address: "Room 1202, Flat A, 12/F, Efficiency House, 35 Tai Yau Street, San Po Kong, Kowloon, Hong Kong香港九龍新蒲崗大有街35號義發工業大廈12樓A座1202室",
        };
    },
    created() {},
    async beforeMount() {},
    methods: {},
};
</script>
<style lang="scss" scoped>
.contact-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    
    .intro-section {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        background-color: #fff;
        padding: 40px 30px;
        margin-bottom: 50px;
        border-radius: 12px;
        box-shadow: 0 6px 15px rgba(0, 0, 0, 0.08);
        animation: fadeInUp 0.8s ease-in-out;
        
        h2 {
            margin-bottom: 25px;
            color: #2c3e50;
            font-size: 2.2rem;
            font-weight: 600;
        }
        
        p {
            font-size: 1.1rem;
            line-height: 1.7;
            color: #555;
            max-width: 800px;
            text-align: center;
        }
    }

    .contact-info-section {
        background: linear-gradient(to right, #f8f9fa, #e9ecef);
        padding: 50px 30px;
        border-radius: 12px;
        margin-bottom: 50px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
        
        .section-header {
            text-align: center;
            margin-bottom: 40px;
            
            h2 {
                color: #2c3e50;
                font-size: 2rem;
                font-weight: 600;
                position: relative;
                display: inline-block;
                
                &:after {
                    content: '';
                    position: absolute;
                    bottom: -10px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 60px;
                    height: 3px;
                    background-color: #3498db;
                }
            }
        }
        
        .contact-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 30px;
            
            .contact-card {
                background-color: white;
                padding: 30px 20px;
                border-radius: 10px;
                box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
                transition: transform 0.3s, box-shadow 0.3s;
                text-align: center;
                
                &:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
                }
                
                .icon-wrapper {
                    width: 70px;
                    height: 70px;
                    margin: 0 auto 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    background: linear-gradient(135deg, #3498db, #2980b9);
                    
                    i {
                        font-size: 28px;
                        color: white;
                    }
                }
                
                h4 {
                    margin-bottom: 15px;
                    color: #2c3e50;
                    font-weight: 600;
                    font-size: 1.2rem;
                }
                
                p {
                    color: #555;
                    font-size: 1rem;
                    line-height: 1.5;
                    word-break: break-word;
                }
            }
        }
    }

    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translateY(30px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @media (max-width: 768px) {
        padding: 15px;
        
        .intro-section {
            padding: 30px 20px;
            
            h2 {
                font-size: 1.8rem;
            }
            
            p {
                font-size: 1rem;
            }
        }
        
        .contact-info-section {
            padding: 30px 20px;
            
            .section-header h2 {
                font-size: 1.6rem;
            }
            
            .contact-grid {
                gap: 20px;
                
                .contact-card {
                    padding: 25px 15px;
                    
                    .icon-wrapper {
                        width: 60px;
                        height: 60px;
                        
                        i {
                            font-size: 24px;
                        }
                    }
                    
                    h4 {
                        font-size: 1.1rem;
                    }
                }
            }
        }
    }
}
</style>
